'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var configuratorHelpers = require('./configuratorHelpers');


// Views already reported this flyout attempt — reset when a fresh "view" fires so back/forward
// navigation between Confirm Honda Centre and Shopper Details cannot double-count a funnel step.
var stepViewsReported = {};

var TEST_DRIVE_TIMER_KEY = 'configuratorTestDrive';
var SIDEBAR_TEST_DRIVE_TIMER_KEY = 'sidebarTestDrive';

// ─── Helpers ──────────────────────────────────────────────────────────────────

// Scoped to the test drive modal/form: the brochure modal reuses the same card, car-data and
// `car-selected-radio-N` markup, so global lookups would mix its selection into this payload.
function buildSelectedModels() {
    var selectedModels = [];
    var $modal = $('#sidebarTestDriveModal');
    var $form = $('#create-test-drive-form');
    var carData = $modal.find('.car-data-object').data('cardata') || [];
    $modal.find('.car-card.is-selected').each(function (index) {
        var selectedCarName = $(this).data('productname');
        var selectedCar = carData.find(function (p) { return p.productName === selectedCarName; });
        if (!selectedCar) return;
        var selectedModel = {
            segments: selectedCar.segment || '',
            displayTitle: selectedCar.productName || '',
            title: selectedCar.productName || '',
            code: selectedCar.code || '',
            sf_model: selectedCar.Model || '',
            sf_grade: selectedCar.grade || '',
            sf_door: selectedCar.Door || '',
            sf_year: selectedCar.sfYear || '',
            year: selectedCar.Year || '',
            variants: []
        };
        var selectedVariantCode = $form.find('input[name="car-selected-radio-' + (index + 1) + '"]:checked').val();
        var selectedVariant = (selectedCar.gradeArray || []).find(function (v) { return v.id === selectedVariantCode; });
        if (selectedVariant) {
            selectedModel.variants.push({
                title: selectedVariant.displayValue || '',
                code: selectedVariant.code || '',
                isDefaultVariant: false,
                transmission: selectedCar.trans || '',
                sfGrade: selectedVariant.id || '',
                sfDoor: selectedCar.Door || ''
            });
        }
        selectedModels.push(selectedModel);
    });
    return selectedModels;
}

// The retired modal-open flow was the only place that populated these two globals (via its own
// AJAX); they default to `{}`, which is truthy, so a flyout-only journey must not push that
// object straight into the data layer as if it were the real code / accessory list.
function getConfiguratorUniqueCode() {
    return typeof window.globalTestDriveuniqueCode === 'string' ? window.globalTestDriveuniqueCode : '';
}

function getConfiguratorAccessoryData() {
    return Array.isArray(window.testDriveGlobalAccessoryData) ? window.testDriveGlobalAccessoryData : [];
}

// ─── Event Handlers ───────────────────────────────────────────────────────────

var events = {

    sidebarTestDrive: function (data) {
        window.sidenavTestDriveUUID = crypto.randomUUID();
        var uuid = window.sidenavTestDriveUUID;
        analyticsHelper.timeStart(SIDEBAR_TEST_DRIVE_TIMER_KEY);

        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';

        dataLayer.push({ 'event': 'custom.menu', 'group': 'side navigation menu', 'category': 'side navigation', 'action': 'click', 'label': 'Book a test drive', 'userRequestId': uuid });
        dataLayer.push({
            'event': 'custom.form',
            'group': 'sidenav_testdrive',
            'category': 'side navigation',
            'action': 'view',
            'userRequestId': uuid,
            'data': { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
            'models': []
        });



        $('#create-test-drive-form').off('change.p2TestDrive').on('change.p2TestDrive', 'input, select, textarea', function () {
            var selectedModels = buildSelectedModels();
            if (analyticsHelper.isFirstFormInteraction('p2_testdrive_sidebar')) {
                dataLayer.push({
                    event: 'custom.form',
                    group: 'book a test drive',
                    category: 'side navigation',
                    action: 'start',
                    userRequestId: window.sidenavTestDriveUUID || uuid,
                    data: { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
                    models: selectedModels
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            dataLayer.push({
                event: 'custom.form',
                group: 'book a test drive',
                category: 'side navigation',
                action: 'interaction',
                field_name: fieldName,
                field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                userRequestId: window.sidenavTestDriveUUID || uuid,
                data: { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
                models: selectedModels
            });
        });
    },

    testDriveSelectModel: function (data) {
        if (!window.sidenavTestDriveUUID) {
            window.sidenavTestDriveUUID = crypto.randomUUID();
        }
        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';
        var selectedModels = buildSelectedModels();
        dataLayer.push({
            'event': 'custom.form',
            'group': 'sidenav_testdrive',
            'category': 'side navigation',
            'action': 'start',
            'userRequestId': window.sidenavTestDriveUUID,
            'data': { 'value': 'undefined', 'optIn': null, 'location': formattedAddress, 'postcode': postalCode, 'timeframe': '', 'dealer': '' },
            'models': selectedModels
        });
    },

    testDriveSelectedModel: function (data) {
    },

    testDriveUserDetails: function (data) {
    },

    // Fires the sidebar form complete step. Bridged from sidebar.js on
    // `testdrive.afterLead.success` (data = $form), so it only runs once the lead is accepted.
    // AWS-942: group is "book a test drive", not the "sidenav_testdrive" used by the view step.
    takeTestDrive: function (data) {
        var $form = (data && data.length) ? data : $('#create-test-drive-form');
        var uuid = window.sidenavTestDriveUUID || crypto.randomUUID();
        var dealerName = $form.find('input[name="user-location-dealers"]:checked').data('dealername') || '';
        var consentValue = $form.find('#test-drive-when-consent').is(':checked');
        var inputLocation = document.getElementById('sidebar-edit-location-summary')
            ? document.getElementById('sidebar-edit-location-summary').textContent.trim() : '';
        var locationParts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
        var formattedAddress = locationParts ? locationParts[1] : inputLocation;
        var postalCode = locationParts ? locationParts[2] : '';
        var selectedModels = buildSelectedModels();
        var timeSpent = analyticsHelper.timeEnd(SIDEBAR_TEST_DRIVE_TIMER_KEY);

        // Snapshot taken above; mint the next funnel id so a repeat submission is a distinct funnel.
        window.sidenavTestDriveUUID = crypto.randomUUID();
        analyticsHelper.timeStart(SIDEBAR_TEST_DRIVE_TIMER_KEY);

        analyticsHelper.hashUserData(analyticsHelper.extractFormPII($form)).then(function (hashedUserData) {
            dataLayer.push({
                'event': 'custom.form',
                'group': 'book a test drive',
                'category': 'side navigation',
                'action': 'complete',
                'event_id': uuid,
                'userRequestId': uuid,
                'timeSpent': timeSpent,
                'userData': hashedUserData,
                'data': {
                    'configurator ID': '',
                    'location': formattedAddress,
                    'postcode': postalCode,
                    'dealer': dealerName,
                    'optIn': consentValue,
                    'insuranceopIn': false,
                    'financeopIn': false
                },
                'models': selectedModels
            });
        });
    },

    configuratorbookATestDrive: function (data) {
        var loc = configuratorHelpers.getConfiguratorLocation();
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, getConfiguratorAccessoryData());

        stepViewsReported = {};
        window.sidenavTestDriveUUID = window.sidenavTestDriveUUID || crypto.randomUUID();
        analyticsHelper.timeStart(TEST_DRIVE_TIMER_KEY);
        dataLayer.push({ 'event': 'custom.cta', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': data.text().trim() });
        dataLayer.push({
            'event': 'custom.form', 'group': 'book a test drive', 'category': 'configurator', 'action': 'view',
            'userRequestId': window.sidenavTestDriveUUID,
            'data': { 'configurator ID': getConfiguratorUniqueCode(), 'location': loc.formattedAddress, 'postcode': loc.postalCode, 'dealer': loc.dealerName },
            models: [selectedModel]
        });
        events.configureTestDriveFormStart(data);
    },

    accordTestDrive: function (data) {
        var carBuildBtn = document.querySelector('#carbuildbtn-primary');
        var carName = carBuildBtn ? carBuildBtn.textContent.replace('Build ', '').replace('Your ', '').replace('your ', '').trim() : '';
        window.sidenavTestDriveUUID = crypto.randomUUID();
        dataLayer.push({ 'event': 'custom.cta', 'group': 'hero', 'category': carName + ' Showroom Page', 'action': 'click', 'label': data.text().trim() });
    },

    configureTestDriveFormStart: function (data) {
        var loc = configuratorHelpers.getConfiguratorLocation();
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, getConfiguratorAccessoryData());
        var configDataObj = {
            'configurator ID': getConfiguratorUniqueCode(),
            'location': loc.formattedAddress,
            'postcode': loc.postalCode,
            'dealer': loc.dealerName
        };
        var startFired = false;

        $('#test-drive-details-form').off('change.configTestDrive').on('change.configTestDrive', 'input, select, textarea', function () {
            if (!startFired) {
                startFired = true;
                dataLayer.push({
                    event: 'custom.form',
                    group: 'book a test drive',
                    category: 'configurator',
                    action: 'start',
                    userRequestId: window.sidenavTestDriveUUID || null,
                    data: configDataObj,
                    models: [selectedModel]
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            dataLayer.push({
                event: 'custom.form',
                group: 'book a test drive',
                category: 'configurator',
                action: 'interaction',
                field_name: fieldName,
                field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                userRequestId: window.sidenavTestDriveUUID || null,
                data: configDataObj,
                models: [selectedModel]
            });
        });
    },

    configureTestDriveFormComplete: function (data) {
        var $form = data;
        var loc = configuratorHelpers.getConfiguratorLocation();
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, getConfiguratorAccessoryData());
        var optIn = $form.find('[name="PrivacyConsent"]').is(':checked');
        var timeSpent = analyticsHelper.timeEnd(TEST_DRIVE_TIMER_KEY);
        var uuid = window.sidenavTestDriveUUID || '';

        analyticsHelper.hashUserData(analyticsHelper.extractFormPII($form)).then(function (hashedUserData) {
            dataLayer.push({
                'event': 'custom.form',
                'group': 'book a test drive',
                'category': 'configurator',
                'action': 'complete',
                'event_id': uuid,
                'userRequestId': uuid,
                'timeSpent': timeSpent,
                'userData': hashedUserData,
                'data': {
                    'configurator ID': getConfiguratorUniqueCode(),
                    'location': loc.formattedAddress,
                    'postcode': loc.postalCode,
                    'dealer': loc.dealerName,
                    'optIn': optIn,
                    'insuranceopIn': false,
                    'financeopIn': false
                },
                models: [selectedModel]
            });
        });
    },

    testDriveStepReached: function (view) {
        var uuid;

        if (stepViewsReported[view]) {
            return;
        }

        uuid = window.sidenavTestDriveUUID || '';
        stepViewsReported[view] = true;
        dataLayer.push({
            'event': 'custom.form',
            'group': 'book a test drive',
            'category': 'configurator',
            'action': 'step',
            'step': view,
            'event_id': uuid,
            'userRequestId': uuid,
            'timeSpent': analyticsHelper.timeLap(TEST_DRIVE_TIMER_KEY)
        });
    }
};

function init() {
    $('body').off('testdrive.afterLead.success.gtm').on('testdrive.afterLead.success.gtm', function (e, response) {
        if (response && !response.error) {
            $('body').trigger('gtm:event', { callback: 'takeTestDrive', data: $('#create-test-drive-form') });
        }
    });
}

module.exports = { init: init, events: events };
